import type { Country } from '../store/types';

export interface MicrosoftEntityInfo {
  entityName: string;
  warningText: string;
}

const USA_ENTITY: MicrosoftEntityInfo = {
  entityName: 'Microsoft Corporation, USA',
  warningText: 'Please note that your legal process must be addressed to Microsoft Corporation, USA.',
};

const IRELAND_ENTITY: MicrosoftEntityInfo = {
  entityName: 'Microsoft Ireland Operations Limited',
  warningText: 'Please note that your legal process must be addressed to Microsoft Ireland Operations Limited, Ireland.',
};

const IRELAND_ENTITY_COUNTRIES = new Set([
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Republic of Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Iceland',
  'Ireland',
  'Italy',
  'Latvia',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Monaco',
  'Netherlands',
  'Norway',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Switzerland',
  'United Kingdom',
]);

export function getMicrosoftEntity(country: Country | null): MicrosoftEntityInfo | null {
  if (!country) {
    return null;
  }

  if (country.internationalWarning?.header) {
    return {
      entityName: country.internationalWarning.header,
      warningText: country.internationalWarning.warningText ||
        `Please note that your legal process must be addressed to ${country.internationalWarning.header}.`,
    };
  }

  if (IRELAND_ENTITY_COUNTRIES.has(country.name)) {
    return IRELAND_ENTITY;
  }

  return USA_ENTITY;
}
